import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialog, MatDialogRef, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';
import { FidelidadeEmail } from '../models/fidelidade-email';
import { Filtro } from '../models/filtro';
import { CarregandoService } from '../services/carregando.service';
import { FidelidadeEmailService } from '../services/fidelidade-email.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { CadastrarFidelidadeEmailComponent } from './cadastrar-fidelidade-email/cadastrar-fidelidade-email.component';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-fidelidade-email',
  templateUrl: './fidelidade-email.component.html',
  styleUrls: ['./fidelidade-email.component.scss']
})
export class FidelidadeEmailComponent implements OnInit {
  emailsFiltrados: FidelidadeEmail[] = [];
  carregando = true;
  campoOrdenacao = 'descricaoClassificacao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<FidelidadeEmailComponent>,
    private fidelidadeEmailService: FidelidadeEmailService,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarEmails();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarEmails();
    this.paginator.firstPage();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarEmails();
  }

  excluirEmail(email: FidelidadeEmail) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o disparo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirEmail');

        this.fidelidadeEmailService.excluir(email.id).subscribe(
          () => {
            this.buscarEmails();
            this.carregandoService.esconde('excluirEmail');
          },
          err => {
            this.carregandoService.esconde('excluirEmail');
            this.notificacaoService.erro(err);
          }
        );
      }
    });
  }

  buscarEmails() {
    this.carregandoService.mostra('buscarEmails');

    this.fidelidadeEmailService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(
        (dados) => {
          this.emailsFiltrados = dados.itens;

          if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.carregandoService.esconde('buscarEmails');
        }
        , err => {
          this.carregandoService.esconde('buscarEmails');
          this.notificacaoService.erro(err);
        }
      );
  }

  novoEmail() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarFidelidadeEmailComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.buscarEmails();
    });
  }

  editarEmail(email: FidelidadeEmail) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarFidelidadeEmailComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { email },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.buscarEmails();
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}